/**
 * FNV-1A hasher. Expects r to be initialized by caller.
 *
 * @public
 */
export var FNV = function (r, s) {
    for (var i = 0; i < s.length; i++) {
        r ^= s.charCodeAt(i);
        r += (r << 1) + (r << 4) + (r << 7) + (r << 8) + (r << 24);
    }
    return r >>> 0;
};
//# sourceMappingURL=fnv.js.map